export default __webpack_public_path__ + "static/media/customized.71c9357f.png";